{
	"card": {
		"annex_hint": "Compare the signed Allegato A with the one the platform generated: they must be the same, signed by hand.",
		"arrows": "Other verifications",
		"birth_date": "Born on",
		"checked_by": "Checked on {{date}}",
		"compliant": "Mark as compliant",
		"compliant_done": "Compliant verification recorded.",
		"compliant_missing": "First tick: {{items}}.",
		"course": "Course",
		"credits": "Credits",
		"decided": "Outcome recorded on {{date}}.",
		"declared": "Declared",
		"document": "Document",
		"documents": "Documents of the application",
		"download": "Download",
		"file_failed": "The file could not be opened. Try again.",
		"for_item": "for {{item}}",
		"iseeu": "ISEEU",
		"ispeu": "ISPEU",
		"matched": "Matches",
		"matches": "Matches",
		"next": "Next verification",
		"no_files": "The application has no files.",
		"not_given": "Not given",
		"passport": "Passport",
		"pre_enrollment": "Pre-enrolment",
		"previous": "Previous verification",
		"recorded_student_number": "Student number recorded",
		"seat_lost": "The student no longer holds the seat: the verification resumes only if they accept a new offer of the residence.",
		"student_number": "Student number",
		"student_number_missing": "The student number is missing: a student who pre-enrolled must give it before the verification is compliant.",
		"tax_code": "Tax code",
		"title": "Verification · {{protocol}}",
		"undo": "Undo",
		"year": "Year"
	},
	"category": {
		"doctoral_and_specialization": "PhD and specialisation",
		"first_year": "First year",
		"later_years": "Later years"
	},
	"columns": {
		"name": "Student"
	},
	"correction": {
		"action": "Correct the outcome",
		"badge": "Corrected",
		"cause": "Cause",
		"cause_text": "Material error of the verification",
		"confirm": "Correct",
		"corrected": "Corrected by {{name}} on {{date}}.",
		"corrected_at": "Corrected on {{date}}.",
		"description": "Only for a material error of the verification, with the proof. The exclusion is annulled, the verification waits again and the student is back in the ranking in their position: they get an offer only if a seat is free.",
		"done": "Outcome corrected: the verification waits again.",
		"download": "Download the proof of the correction",
		"proof_hint": "The document that shows the error of the verification.",
		"title": "Correct the outcome of the verification"
	},
	"difference": {
		"action": "Different value",
		"admission_gained": "Also admitted to the {{quota}} quota.",
		"admission_lost": "No longer admitted to the {{quota}} quota.",
		"check": "Check",
		"close": "Close",
		"description": "Write the value the document shows. The platform calculates the ranking again with it and tells you whether anything changes.",
		"has_effect": "The documented value changes the outcome: it is not a difference to note. Exclude with \"Does not match\" and the cause of the value.",
		"in_favour": "The documented value is in the student's favour: it is no cause to exclude, and the ranking stays on the declared data. Note the difference: the check counts as done.",
		"line": "{{field}}: declared {{declared}}, documented {{documented}}",
		"no_effect": "It changes neither the admission nor the position. Note the difference: the check counts as done.",
		"note": "Note",
		"note_hint": "Optional. For example, where the value comes from.",
		"noted": "Difference with no effect",
		"position_changed": "The position in the category goes from {{from}} to {{to}}.",
		"position_lost": "Leaves the ranking of the category, where it is number {{from}}.",
		"position_new": "The position in the category becomes {{to}}.",
		"record": "Note the difference",
		"recorded": "Difference noted.",
		"title": "Different value in the document",
		"unchanged": "It is the declared value: if the document matches, use \"Matches\"."
	},
	"exclusion": {
		"action": "Does not match",
		"cause": "Cause",
		"confirm": "Exclude",
		"description": "Choose the cause, attach the proof and confirm. The offer is revoked, the seat goes to the next one and the student gets an email.",
		"documented": "Value in the document",
		"done": "Assignee excluded. The seat goes to the next one.",
		"download": "Download the proof",
		"download_failed": "The proof could not be opened. Try again.",
		"note": "Note",
		"note_hint": "Optional.",
		"proof_hint": "The document that does not match what was declared.",
		"recorded": "Recorded by {{name}} on {{date}}.",
		"recorded_at": "Recorded on {{date}}.",
		"summary": "Exclusion",
		"title": "Exclude the assignee",
		"without_effect": "The value in the document changes neither the admission nor the position: note the difference with \"Different value\"."
	},
	"item": {
		"credits": "Credits",
		"economic": "ISEEU and ISPEU",
		"enrollment": "Enrolment and student number",
		"identity": "Identity document",
		"signed_annex": "Signed Allegato A"
	},
	"quota": {
		"q30": "30% quota",
		"q70": "70% quota"
	},
	"state": {
		"compliant": "Compliant",
		"excluded": "Excluded",
		"pending": "Pending"
	},
	"student_number": {
		"confirm": "Record",
		"date": "Arrived on",
		"description": "The number the student sent in reply to the request. Attach the message as proof, if there is one.",
		"done": "Student number recorded.",
		"number": "Student number",
		"proof_hint": "Optional. The message with the number: an .eml tells when it arrived.",
		"proposed": "Date and time read from the message: check them before recording.",
		"reading": "Reading the message",
		"received": "Arrived on {{date}}.",
		"record": "Record the student number",
		"request": "Ask for the student number",
		"request_again": "Ask again",
		"request_done": "Request sent to the student.",
		"requested": "Asked on {{date}}.",
		"time": "Time",
		"title": "Record the student number"
	},
	"to_check": {
		"student_number": "Student number"
	}
}
